import React, {useEffect, useState} from "react";
import {useSelector} from "../../shared-services/redux-tiny";
import useModalQueue from "../topLayer/modals/useModalQueue";
import {t, translateCollection} from "../../shared-services/translate";
import styled from "styled-components";
import {FaInfoCircle} from "react-icons/fa";
import InfoFarmyModal from "../topLayer/modals/InfoFarmyModal";
import currentTheme from "../../react-themes/theme";
import {mediaQuery} from "../../react-components/shared/GlobalStyles";

const theme = currentTheme();

const handlingFee = "7.90";
const decimals = 2;

const CartInfoMessage = ({currentCart, textColor, layout, displayModal = false}) => {
  const {currentUser, marketingZone} = useSelector(state => state.session);
  const [infoType, setInfoType] = useState(null);
  const [translations, setTranslations] = useState({});

  const {pushToQueue} = useModalQueue();

  useEffect(() => {
    if (currentCart?.item_total < currentCart?.minimum_order_value) {
      setInfoType("mov");
      const bodyKey = marketingZone === "A" ? "_zone_a" : "2";
      setTranslations({
        title: t("cart.mov_modal.title"),
        body: t(`cart.mov_modal.body${bodyKey}`, {mov_regular: window.MinimumOrderValueRegular, mov_reduced: window.MinimumOrderValueReduced})
      });
    } else if (!currentUser?.hasActiveSubscription) {
      if (currentCart?.handling_fee > 0) {
        currentCart?.item_total < currentCart?.min_value_for_free_handling ? setInfoType("handling_fee") : setInfoType("handling_fee_reached");
      } else {
        setInfoType("handling_fee_reached");
      }
      setTranslations({
        title: t("cart.handling_fee_modal.title"),
        body: t("cart.handling_fee_modal.body")
      });
    } else {
      setInfoType(null);
    }
  }, [currentCart?.item_total, currentCart?.handling_fee, currentUser?.hasActiveSubscription, currentCart?.minimum_order_value]);

  const openInfoModal = () => {
    pushToQueue("InfoFarmyModal:HandlingFee");
  };

  return <StyledInfoMessage textColor={textColor} className={`${!infoType ? "hide-message" : ""} ${layout} ${infoType}`}>
    {displayModal && <InfoFarmyModal
      modalName="InfoFarmyModal:HandlingFee"
      title={translations?.title}
      body={translations?.body}
    />}
    {infoType && <div className="flex justify-content-center align-items-center">
      {infoType === "mov" &&
        <InfoContentMov currentCart={currentCart} layout={layout} onIconClick={openInfoModal}/>}
      {infoType === "handling_fee" &&
        <InfoContentHandlingFee currentCart={currentCart} onIconClick={openInfoModal}/>}
      {infoType === "handling_fee_reached" &&
        <InfoContentHandlingFeeReached handlingFee={handlingFee} onIconClick={openInfoModal}/>}
    </div>}
  </StyledInfoMessage>;
};

export default CartInfoMessage;

const InfoContentMov = ({currentCart, layout, onIconClick}) => {
  const [content, setContent] = useState();

  useEffect(() => {
    const displayedValue = layout === "desktop"
      ? (currentCart?.minimum_order_value - currentCart?.item_total).toFixed(decimals)
      : currentCart?.minimum_order_value.toFixed(decimals);
    const highlightClass = (position, layout) => {
      return (position === 1 || position === 3) && layout === "desktop" ? "highlight" : ""; // eslint-disable-line no-magic-numbers
    };
    const translation = translateCollection(`cart.info_mov.${layout}`, {mov: displayedValue});
    const contentElements = translation.map((text, index) => {
      return (<span key={`info-part-${index}`} className={highlightClass(index, layout)}>
        {text}
      </span>);
    });
    setContent(contentElements);
  }, [layout, currentCart?.item_total, currentCart?.minimum_order_value]);

  return (
    <span className={"text-align-center"}>{content}<FaInfoCircle className={`cursor-pointer ${layout === "desktop" ? "highlight" : ""}`} onClick={onIconClick}/></span>
  );
};

const InfoContentHandlingFee = ({currentCart, onIconClick}) => {
  return (
    <span>
      {
        t("cart.handling_fee_info",
          {
            remaining: (currentCart?.min_value_for_free_handling - currentCart?.item_total).toFixed(decimals),
            handling_fee: currentCart?.handling_fee.toFixed(decimals)
          })
      }
      <FaInfoCircle className={"margin-left-10 cursor-pointer"} onClick={onIconClick}/>
    </span>
  );
};

const InfoContentHandlingFeeReached = ({handlingFee, onIconClick}) => {
  return (
    <span>
      {t("cart.handling_fee_reached_info", {handling_fee: handlingFee})}
      <FaInfoCircle className={"margin-left-10 cursor-pointer"} onClick={onIconClick}/>
    </span>
  );
};

export const StyledInfoMessage = styled.div`
  color: ${props => props.textColor || theme.colors.textColor};
  font-weight: bold;
  background-color: #E4EBE6;
  border-radius: 5px;
  padding: 9px;

  ${mediaQuery("sm")`
    background-color: #FFFFFF;
    border-radius: 0;
    padding: 0;
    font-size: 14px;
  `}
  .icon-wrapper {
    min-width: 16px;

    svg {
      cursor: pointer;
      width: 16px;
    }
  }
  &.hide-message {
    display: none;
  }
  .highlight {
    color: #F65B2D;
  }
  &.desktop.mov {
    background-color: rgba(246, 91, 45, 0.09);
    color: ${theme.colors.textColor};
  }
`;
